import { useEffect } from "react";
import { queryOptions, useQuery } from "@tanstack/react-query";

import { getDietitianAccountAPI } from "@client/settings/getDietitianAccountAPI";
import { endOfDay, isAfter } from "date-fns";
import { toDate } from "@utils/date";
import { settingsKeys } from "./settingsKeys";

export const dietitianAccountQuery = queryOptions({
  queryKey: settingsKeys.dietitianAccount(),
  queryFn: getDietitianAccountAPI,
});

export const useFetchDietitianAccountQuery = () => {
  const { data, ...rest } = useQuery(dietitianAccountQuery);

  useEffect(() => {
    if (data) {
      const subscription = data?.data?.clinic?.subscription;

      window.subscriptionOK =
        subscription && subscription.finishedAt
          ? isAfter(endOfDay(toDate(subscription.finishedAt)), new Date())
          : true;
    }
  }, [data]);

  return { account: data?.data, ...rest };
};
